import { render } from "./ledordmodule.vue?vue&type=template&id=4cc153fa&scoped=true"
import script from "./ledordmodule.vue?vue&type=script&lang=js"
export * from "./ledordmodule.vue?vue&type=script&lang=js"

import "./ledordmodule.vue?vue&type=style&index=0&id=4cc153fa&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cc153fa"]])

export default __exports__